import { RootState } from 'store';

export const selectHasDirtyForm = (state: RootState) =>
  state.uiState.hasDirtyForm;

export const selectHeaderMode = (state: RootState) => state.uiState.headerMode;
